"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Ctrl_1 = require("./Ctrl");
var Utils_1 = require("../core/Utils");
var Enum_1 = require("../core/Enum");
var CtrlCollection = function () {
  function CtrlCollection(name) {
    if (name === void 0) {
      name = null;
    }
    this.name = name || null;
    this.message = null;
    this.required = [];
    this.__collection = [];
  }
  Object.defineProperty(CtrlCollection.prototype, "collection", {
    get: function get() {
      return this.__collection;
    },
    set: function set(value) {
      this.__collection = value;
    },
    enumerable: true,
    configurable: true
  });
  CtrlCollection.prototype.add = function (controlArgs) {
    try {
      if (!controlArgs) {
        throw new TypeError("Please provide a valid `Ctrl`, `CtrlCollection` or parameters to create a control.");
      }
      if (controlArgs instanceof Ctrl_1.default || controlArgs instanceof CtrlCollection) {
        this.__collection.push(controlArgs);
      } else if (Array.isArray(controlArgs)) {
        var tempCollection = new CtrlCollection();
        for (var i = 0; i < controlArgs.length; i++) {
          tempCollection.add(controlArgs[i]);
        }
        this.__collection.push(tempCollection);
      } else if (!Utils_1.ValidateCtrlProps(controlArgs)) {
        throw new TypeError("You must provide at least a `name` attribute to a `Ctrl`.");
      } else {
        this.__collection.push(new Ctrl_1.default(controlArgs));
      }
      return this;
    } catch (e) {
      console.error(e);
      return null;
    }
  };
  CtrlCollection.prototype.get = function (name, subCollection) {
    if (subCollection === void 0) {
      subCollection = null;
    }
    for (var i = 0; i < this.__collection.length; i++) {
      var current = this.__collection[i];
      if (subCollection !== null && subCollection !== "") {
        if (subCollection === current.name && current instanceof CtrlCollection) {
          return current.get(name);
        }
      } else {
        if (current instanceof CtrlCollection) {
          var item = current.get(name);
          if (item !== false) return item;
        }
        if (name === current.name) {
          return current;
        }
      }
    }
    return false;
  };
  CtrlCollection.prototype.getValue = function (name, subCollection) {
    if (subCollection === void 0) {
      subCollection = null;
    }
    var ctrl = this.get(name, subCollection);
    if (ctrl instanceof CtrlCollection) return undefined;
    if (ctrl instanceof Ctrl_1.default) return ctrl.value;
    return undefined;
  };
  CtrlCollection.prototype.set = function (control, subCollection) {
    if (subCollection === void 0) {
      subCollection = null;
    }
    for (var i = 0; i < this.__collection.length; i++) {
      var current = this.__collection[i];
      if (typeof subCollection !== "boolean" && subCollection !== null && subCollection !== undefined && subCollection !== "") {
        if (subCollection === current.name && current instanceof CtrlCollection) {
          this.__collection[i].set(control);
          return this;
        }
      } else {
        if (control.name === current.name) {
          this.__collection[i] = control;
          return this;
        } else if (current instanceof CtrlCollection) {
          this.__collection[i].set(control);
          return this;
        }
      }
    }
    this.__collection.push(control);
    return this;
  };
  CtrlCollection.prototype.setValue = function (name, value, subCollection) {
    if (subCollection === void 0) {
      subCollection = null;
    }
    for (var i = 0; i < this.__collection.length; i++) {
      var current = this.__collection[i];
      if (typeof subCollection !== "boolean" && subCollection !== null && subCollection !== undefined && subCollection !== "") {
        if (subCollection === current.name && current instanceof CtrlCollection) {
          this.__collection[i].setValue(name, value);
          return this;
        }
      } else {
        if (name === current.name) {
          this.__collection[i].value = value;
        } else if (current instanceof CtrlCollection) {
          this.__collection[i].setValue(name, value);
        }
      }
    }
    return this;
  };
  CtrlCollection.prototype.remove = function (name, subCollection) {
    if (subCollection === void 0) {
      subCollection = null;
    }
    for (var i = 0; i < this.__collection.length; i++) {
      var current = this.__collection[i];
      if (typeof subCollection !== "boolean" && subCollection !== null && subCollection !== undefined && subCollection !== "") {
        if (subCollection === current.name && current instanceof CtrlCollection) {
          this.__collection[i].remove(name);
        }
      } else {
        if (name === current.name) {
          this.__collection.splice(i, 1);
        } else if (current instanceof CtrlCollection) {
          this.__collection[i].remove(name);
        }
      }
    }
    return this;
  };
  CtrlCollection.prototype.validate = function () {
    var status = true,
      messages = [],
      required = [];
    for (var i = 0; i < this.__collection.length; i++) {
      var current = this.__collection[i],
        currentValidation = current.validate();
      if (!currentValidation) {
        if (current instanceof Ctrl_1.default) {
          if (current.type === Enum_1.CtrlType.HIDDEN) {
            messages.push(current.message);
          } else if (current.required) {
            required.push("'" + current.name);
          }
        } else if (current instanceof CtrlCollection) {
          if (current.message) {
            messages.push(current.message);
          }
          if (current.required.length > 0) {
            required = required.concat(current.required);
          }
        }
      }
      status = currentValidation && status;
    }
    this.message = messages.length > 0 ? messages.join("\r\n") : null;
    this.required = required;
    return status;
  };
  CtrlCollection.prototype.invalidate = function (name, message, subCollection) {
    if (subCollection === void 0) {
      subCollection = null;
    }
    var ctrl = this.get(name, subCollection);
    if (ctrl instanceof Ctrl_1.default) ctrl.invalidate(message);
    return this;
  };
  CtrlCollection.prototype.invalidateAll = function () {
    for (var i = 0; i < this.__collection.length; i++) {
      if (this.__collection[i] instanceof CtrlCollection) {
        this.__collection[i].invalidateAll();
      } else {
        this.__collection[i].invalidate();
      }
    }
    return this;
  };
  CtrlCollection.prototype.toObject = function (useAlias) {
    if (useAlias === void 0) {
      useAlias = false;
    }
    return this.toJSON(useAlias);
  };
  CtrlCollection.prototype.toJSON = function (useAlias) {
    if (useAlias === void 0) {
      useAlias = false;
    }
    var returnable = {};
    for (var c = 0; c < this.__collection.length; c++) {
      var current = this.__collection[c];
      if (current instanceof CtrlCollection) {
        if (current.name) {
          returnable[current.name] = current.toJSON(useAlias);
        } else {
          var tempObject = current.toJSON(useAlias);
          for (var key in tempObject) {
            returnable[key] = tempObject[key];
          }
        }
      } else {
        if (useAlias && current.alias !== null && current.alias !== "") {
          returnable[current.alias] = current.toJSON()["value"];
        } else {
          returnable[current.name] = current.toJSON()["value"];
        }
      }
    }
    return returnable;
  };
  CtrlCollection.prototype.toString = function () {
    return "[object CtrlCollection]";
  };
  return CtrlCollection;
}();
exports.default = CtrlCollection;